import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultContactSubsectionStyles = makeStyles(
  () => ({
    root: {
      paddingBottom: '20mm',
    },
  }),
);
